import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Zap, ClipboardCheck } from "lucide-react";
import PhoneMockup from "./PhoneMockup";
import { Chapter } from "./Reveal";

const Demo = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const phoneY = useTransform(scrollYProgress, [0, 1], [48, -48]);
  const chipAY = useTransform(scrollYProgress, [0, 1], [80, -40]);
  const chipBY = useTransform(scrollYProgress, [0, 1], [100, -60]);

  return (
    <section ref={ref} className="relative overflow-hidden py-16 sm:py-24" data-testid="product-showcase">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Chapter num="01" label="See it in action" />
        <div className="relative mt-12 flex flex-col items-center">
          <div className="absolute left-1/2 top-1/2 -z-10 h-[105%] w-[125%] max-w-xl -translate-x-1/2 -translate-y-1/2 rounded-[4rem] bg-guinep-soft" />

          <motion.div style={{ y: phoneY }} className="relative">
            <PhoneMockup variant="island" />

            <motion.div style={{ y: chipAY }} className="absolute -left-6 top-6 hidden sm:block lg:-left-28">
              <motion.div
                animate={{ y: [0, -8, 0] }}
                transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
                className="flex items-center gap-2 rounded-xl border border-guinep-line bg-white px-4 py-3 shadow-[0_16px_40px_-16px_rgba(31,58,43,0.3)]"
              >
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-guinep-soft text-guinep-mid">
                  <Zap size={13} strokeWidth={2.5} />
                </span>
                <div>
                  <p className="text-xs font-semibold text-guinep-ink">Now updated</p>
                  <p className="text-[11px] text-guinep-mute">3 slots open Friday</p>
                </div>
              </motion.div>
            </motion.div>

            <motion.div style={{ y: chipBY }} className="absolute -right-6 bottom-12 hidden sm:block lg:-right-28">
              <motion.div
                animate={{ y: [0, 9, 0] }}
                transition={{ duration: 6, repeat: Infinity, ease: "easeInOut", delay: 1 }}
                className="flex items-center gap-2 rounded-xl border border-guinep-line bg-white px-4 py-3 shadow-[0_16px_40px_-16px_rgba(31,58,43,0.3)]"
              >
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-guinep-soft text-guinep-mid">
                  <ClipboardCheck size={13} strokeWidth={2.5} />
                </span>
                <div>
                  <p className="text-xs font-semibold text-guinep-ink">New enquiry</p>
                  <p className="text-[11px] text-guinep-mute">Gel Manicure · Fri 2 PM</p>
                </div>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Demo;
